<template>
  <div class="module-content">
    <!-- Header -->
    <div class="module-header">
      <div class="left">
        <h2>Supporters</h2>
        <i class="icn icn-refresh mr-2 text-primary-500 refresh" title="Refresh list" @click="fetchSupporters()"></i>
      </div>
      <div class="flex flex-row bg-primary-100 items-center rounded">
        <div class="flex items-center mr-2 bg-primary-500 py-2 px-2 rounded-l text-white">
          <i class="icn icn-information-circle"></i>
        </div>
        <div class="py-2 pr-2 text-primary-500">Displaying top 100 recently active supporters.</div>
      </div>
    </div>

    <!-- Loading -->
    <div v-if="isLoading" class="container w-max">
      <div class="flex flex-col items-center">
        <img class="h-36 mt-20" src="@/assets/img/loading.svg" />
        <h2>Fetching supporter</h2>
      </div>
    </div>

    <!-- List of the users -->
    <div v-if="!isLoading" class="container">
      <div class="table-wrapper">
        <Table :items="filterItems" :attributes="tableAttributes" :options="tableOptions" @edit="viewSupporter"></Table>
      </div>
    </div>
  </div>
</template>

<script>
import { MESSAGES } from '@/helpers/constants';
import Table from '@/components/Table.vue';

export default {
  name: 'SupporterList',

  components: {
    Table,
  },

  data() {
    return {
      isLoading: false,
      lastTimestamp: Date.now(),
      tableOptions: {
        edit: true,
        delete: false,
        editLabel: 'View',
        blockPageOnUpdate: true,
        pages: [25, 50, 100],
      },
      tableAttributes: [
        { name: 'id', label: 'Id' },
        { name: 'name', label: 'Name' },
        { name: 'email.contact', label: 'Email' },
        { name: 'phoneNumber.contact', label: 'Phone' },
        { name: 'address.addressLines', label: 'Address' },
      ],
      filterItems: [],
      limit: 100,
    };
  },

  async beforeMount() {
    await this.fetchSupporters();
  },

  methods: {
    fetchSupporters() {
      this.isLoading = true;
      let timestamp = Date.now(); // timestamp for this api call
      this.lastTimestamp = timestamp; // 1 , 2 , 3

      // Get 100 recently active supporters
      this.$store
        .dispatch('supporters/get', { sort: '-updatedAt' })
        .then(({ data }) => {
          console.log(data);
          if (timestamp >= this.lastTimestamp) {
            this.processSupporters(data);
          }
        })
        .catch((err) => {
          console.error(err);
          let msg = 'Please try again later or contact an administrator.';
          if (err && err.status && err.status === 401) {
            msg = 'You cannot list the items. Please try again later or contact an administrator.';
          }
          this.$store.dispatch('notifications/error', {
            headline: MESSAGES.ERROR_FETCH,
            details: msg,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    processSupporters(supporters) {
      const items = [];

      for (const s of supporters) {
        const sup = {
          id: s.id,
          name: `${s.firstName || s.name || ''} ${s.lastName || ''}`,
        };

        sup.email =
          s.contacts.find((c) => c.type === 'email' && c.isPrimary === true) ||
          s.contacts.find((c) => c.type === 'email');

        sup.phoneNumber =
          s.contacts.find((c) => c.type === 'phone' && c.isPrimary === true) ||
          s.contacts.find((c) => c.type === 'phone');

        // Get the primary address to display
        sup.address = s.addresses.find((s) => s.isPrimary === true) || s.addresses[0];

        if (sup.address && sup.address.addressLines && sup.address.addressLines.includes('undefined')) {
          delete sup.address;
        }

        items.push(sup);
      }

      this.filterItems = items;
    },
    viewSupporter(item) {
      this.$router.push({ name: 'supporter-view', params: { id: item.id } });
    },
  },
};
</script>

<style lang="scss" scoped>
.refresh {
  padding-left: 10px;

  &:hover {
    @apply text-primary-600 cursor-pointer;
  }
}
</style>
